import { Checkbox, Input, Label } from "ui";

export interface MultipleChoiceBaseProps {
  options: { label: string; value: string }[];
  onChange(value: string[]): void;
  value: string[];
  hasOtherOption: boolean;
  otherOptionValue: string;
  onOtherOptionValueChange(value: string): void;
  disabled?: boolean;
}

export type MultipleChoiceProps = MultipleChoiceBaseProps;

export function MultipleChoice(props: MultipleChoiceProps) {
  return (
    <>
      <div className="flex flex-col gap-2">
        {props.options.map((option) => (
          <div key={option.value} className="flex items-center space-x-2">
            <Checkbox
              disabled={props.disabled}
              id={option.value}
              checked={props.value.includes(option.value)}
              onCheckedChange={(checked) => {
                const newValue = checked
                  ? [...props.value, option.value]
                  : props.value.filter((o) => o !== option.value);
                props.onChange(newValue);
              }}
            >
              {option.label}
            </Checkbox>
            <Label htmlFor={option.value}>{option.label}</Label>
          </div>
        ))}
        {props.hasOtherOption && (
          <div className="flex items-center space-x-2">
            <Label htmlFor="other-option">Other:</Label>
            <Input
              id="other-option"
              value={props.otherOptionValue}
              onChange={(e) => {
                props.onOtherOptionValueChange(e.target.value);
              }}
              disabled={props.disabled}
            />
          </div>
        )}
      </div>
    </>
  );
}
